
import { BehaviorSubject, Observable } from "rxjs";
import { IChangeset } from "BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/lib/interfaces/IChangeset";
import { IGrid } from "BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/lib/interfaces/IGrid";

export class ChangeSetService implements IChangeset {
  changesetArr: Array<{ Grid: IGrid }> = [];
}
